const pad = (valor, largo) => String(valor).padStart(largo, "0");

export const fechaIsoLocal = (fecha = new Date()) => {
  const valor = new Date(fecha);
  return `${valor.getFullYear()}-${pad(valor.getMonth() + 1, 2)}-${pad(valor.getDate(), 2)}`;
};

export const rangoInicialComprobantes = (hoy = new Date()) => {
  const hasta = new Date(hoy);
  const desde = new Date(hoy);
  desde.setDate(desde.getDate() - 29);
  return { FechaDesde: fechaIsoLocal(desde), FechaHasta: fechaIsoLocal(hasta) };
};

export const analizarNumeroComprobante = (entrada = "") => {
  const texto = String(entrada).trim();
  if (!texto) return { NumeroComprobante: "", PuntoVenta: null, Numero: null };
  const compuesto = texto.match(/(\d{1,5})\s*-\s*(\d{1,8})(?!\d)/);
  if (compuesto) {
    return {
      NumeroComprobante: texto,
      PuntoVenta: Number(compuesto[1]),
      Numero: Number(compuesto[2]),
    };
  }
  const soloNumero = texto.match(/^\d+$/);
  return {
    NumeroComprobante: texto,
    PuntoVenta: null,
    Numero: soloNumero ? Number(texto) : null,
  };
};

const enteroOpcional = (valor) => {
  const numero = Number(valor);
  return valor !== null && valor !== "" && Number.isInteger(numero) && numero > 0 ? numero : null;
};

export const crearRequestComprobantes = (filtros, tipo = "facturas") => {
  const numero = analizarNumeroComprobante(filtros.NumeroComprobante);
  const request = {
    EmpresaId: filtros.EmpresaId,
    FechaDesde: filtros.FechaDesde,
    FechaHasta: filtros.FechaHasta,
    Texto: String(filtros.Texto || "").trim(),
    NumeroComprobante: numero.NumeroComprobante,
    Estado: filtros.Estado || "",
    PuntoVenta: numero.PuntoVenta,
    Numero: numero.Numero,
    Pagina: Math.max(1, Number(filtros.Pagina) || 1),
    TamanoPagina: Math.max(1, Number(filtros.TamanoPagina) || 50),
  };
  const clienteId = enteroOpcional(filtros.ClienteId);
  if (clienteId) request.ClienteId = clienteId;
  if (tipo === "facturas") {
    request.FacturaId = enteroOpcional(filtros.FacturaId);
    request.TipoComprobanteId = enteroOpcional(filtros.TipoComprobanteId);
    request.RemitoNumero = String(filtros.RemitoNumero || "").trim();
  } else {
    request.RemitoId = enteroOpcional(filtros.RemitoId);
  }
  return request;
};

export const validarFiltrosComprobantes = (filtros) => {
  if (!filtros.EmpresaId) return "No se encontro la conexion a la base de datos.";
  if (!filtros.FechaDesde || !filtros.FechaHasta) return "Selecciona ambas fechas.";
  if (filtros.FechaDesde > filtros.FechaHasta) return "La fecha desde no puede ser posterior a la fecha hasta.";
  const exacta = Boolean(filtros.FacturaId || filtros.RemitoId || analizarNumeroComprobante(filtros.NumeroComprobante).Numero);
  const dias = Math.floor((new Date(`${filtros.FechaHasta}T12:00:00`) - new Date(`${filtros.FechaDesde}T12:00:00`)) / 86400000);
  if (!exacta && dias > 365) return "El rango maximo de consulta es de 366 dias.";
  return "";
};

export const paginasComprobantes = (total, tamano) => Math.max(1, Math.ceil((Number(total) || 0) / (Number(tamano) || 50)));

export const puedeReintentarFactura = (factura) =>
  Boolean(factura?.PuedeReintentarArca) && !["Autorizada", "Anulada"].includes(factura?.Estado);

export const accionesFacturaHistorial = (factura) => ({
  detalle: true,
  pdf: Boolean(factura?.PuedeDescargarPdf),
  reintentar: puedeReintentarFactura(factura),
});

export const accionesRemitoHistorial = (remito) => ({
  detalle: true,
  factura: Boolean(remito?.FacturaId),
  facturar: Boolean(remito?.PuedeFacturar),
});

export const parametrosDetalleRelacionado = (params, tipo, id) => {
  const nuevos = new URLSearchParams(params);
  nuevos.set("tab", tipo);
  if (tipo === "facturas") { nuevos.set("factura", String(id)); nuevos.delete("remito"); }
  else { nuevos.set("remito", String(id)); nuevos.delete("factura"); }
  return nuevos;
};

export const claseEstadoComprobante = (estado = "") => {
  if (/autorizada|facturado/i.test(estado)) return "exito";
  if (/error/i.test(estado)) return "error";
  if (/anulad/i.test(estado)) return "anulado";
  return "pendiente";
};

export const nombreArchivoContentDisposition = (valor, alternativo) => {
  const utf = String(valor || "").match(/filename\*=UTF-8''([^;]+)/i);
  const simple = String(valor || "").match(/filename="?([^";]+)"?/i);
  try { return decodeURIComponent((utf?.[1] || simple?.[1] || alternativo).trim()); }
  catch { return alternativo; }
};
